import Vue from 'vue'
import Router from 'vue-router'
import ShareComputer from '@/view/hipc/ShareComputer'
import ShareFilesDetail from '@/view/hipc/ShareFilesDetail'
import ShareFilesDetail2 from '@/view/hipc/ShareFilesDetail2'
import notFound from '@/view/404.vue'
import MiLogin from '@/view/hipc/MiLogin'
import vip from '@/view/hipc/vip'
import PreviewFile from '@/view/hipc/PreviewFile'
import FileTransfer from "@/view/hipc/FileTransfer"
import CloudLink from "@/view/hipc/CloudLink"
import Statistics from "@/view/hipc/Statistics"
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/CloudLink',
    name: 'CloudLink',
    component: CloudLink,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '随时随地，连接PC'
      }
    }
  },
  {
    path: '/FileTransfer',
    name: 'FileTransfer',
    component: FileTransfer,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '文件快传！'
      }
    }
  },
  {
    path: '/pc/:encryption_key',
    name: 'ShareComputer',
    component: ShareComputer,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '来瞧一瞧我万元组装的电脑！'
      }
    }
  },
  {
    path: '/ShareFilesDetail/:version',
    name: 'ShareFilesDetail',
    component: ShareFilesDetail,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '随时随地，连接PC'
      }
    }
  },
  {
    path: '/s/:id',
    name: 'ShareFiles',
    component: ShareFilesDetail2,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '随时随地，连接PC'
      }
    }
  },
  {
    path: '/ShareFilesDetail2',
    name: 'ShareFilesDetail2',
    component: ShareFilesDetail2,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '随时随地，连接PC'
      }
    }
  },
  {
    path: '/PreviewFile',
    name: 'PreviewFile',
    component: PreviewFile,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: '随时随地，连接PC'
      }
    }
  },
  {
    path: '/Statistics',
    name: 'Statistics',
    component: Statistics,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: 'iWin11交易统计'
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: MiLogin,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: ''
      }
    }
  },
  {
    path: '/vip/:token',
    name: 'vip',
    component: vip,
    meta: {
      content: {
        keywords: 'HiPC！',
        description: ''
      }
    }
  },
  {
    name: '404',
    path: '/404',
    component: notFound
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js